// Mirrors EMI3.Reporting subscription run-status enum. Used by the profile
// subscription cards to colour-code last-run state.
export const SubscriptionRunStatuses = Object.freeze({
	None: "None",
	Success: "Success",
	Failed: "Failed",
});
